<template>
  <div class="rightbox">
    <Hot1 v-if="hot1.length>0" :list="hot1" />
    <Hot2 v-if="hot2.length>0" :list="hot2" />
    <Hot3 v-if="hot3.length>0" :list="hot3" />
    <Hot4 v-if="hot4.length>0" :list="hot4" />
  </div>
</template>
<script>
import Hot1 from '@/components/commonRightNew/hot1/index.vue'
import Hot2 from '@/components/commonRightNew/hot2/index.vue'
import Hot3 from '@/components/commonRightNew/hot3/index.vue'
import Hot4 from '@/components/commonRightList/hot3/index.vue'
import { getTJShow } from '@/api/api.js'
import { getRightData } from '@/api/api.js'
// import { formatTime } from '@/utils/timeFormat'
export default {
  components: { Hot1, Hot2, Hot3, Hot4 },
  data() {
    return {
      hot1: [],
      hot2: [],
      hot3: [],
      hot4: []
    }
  },
  mounted() {
    getTJShow({ index: 1, size: 5, showType: 2 }).then(res => {
      this.hot1 = res.data
    })
    getTJShow({ index: 1, size: 5, showType: 4 }).then(res => {
      this.hot2 = res.data
      for (var i = 0; i < this.hot2.length; i++) {
        this.hot2[i].SHOW_THUMB_URL
        var str = /^http/
        if (!str.test(this.hot2[i].SHOW_THUMB_URL)) {
          this.hot2[i].SHOW_THUMB_URL = null
        }
      }
    })
    getTJShow({ index: 1, size: 5, showType: 3 }).then(res => {
      this.hot3 = res.data
    })
    getRightData().then(res => {
      this.hot4 = res.data.latestNews
    })
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>
